

export const ProjectData = [
  { 
   id: 1,
   title: '921 Steak',
   url: 'https://www.921steak.com/',
   repo: 'https://github.com/REST-a-site',
   description: 'A fullstack restaurant applicaiton complete with admin login, a Opentable tester widget, and full CRUD functionality to update the menu component from the front end.  Checkout the Github ReadMe for login credentials!',
   image: 'https://images.unsplash.com/photo-1598930230137-27b0b22154fc?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2100&q=80',
   alt: 'steak plate',
  },
  { 
    id: 2,
    title: 'Vaxine',
    url: 'https://vaxine.netlify.app/',
    repo: 'https://github.com/Covid-Bookings/Front-End-Covid-Bookings',
    description: 'Schedule your Coronavirus vaccine today using Vaxine! Built over a three-day hackathon in Feburary 2021 by a team of three UX Designers and three Software Engineers, and sponsored by General Assembly, this front-end web application earned second place out of eight total teams.',
    image: 'https://s3-alpha-sig.figma.com/img/75ba/3b50/4d3e8be4eb2eb0e667d81550969d5131?Expires=1614556800&Signature=bm~TOQ~I0Pz7nXvm4p5FQde58eO1s44OKBuP9ijkLSZS2f--28w3nuLE8yHV55DyyBlYUu~qxb0jy~4cvKNVwk3bkgjcLROPK7wxZ3MNJPcYFijfLNz5CTEGo0Eb4-XCDHdmWqSSDMhcjJb4Iq~X3zjYsOkMEVeu3y3SvirYVKQPb5iTYu7IPGkxwSOALUv3DPLVHePb-hd9SQvUWJDH~BkxK2dQquoDs4PGTCwT7T5t5Y3PzaYWWaouMolQopWQwLQpdGISUvtbhOS2OpavobWAMVIcJaujW-xhhrj7y03MeflnnpNp1jwnMhwcDPjvg~0Ppr1bQQwWAle~PGAGyA__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA',
    alt: "Vaxine logo",
   },
  { 
    id: 3,
    title: 'Portfolio',
    description: 'Built with React styled components, React Icons, smooth-scroll, and carousel, this front-end application features a form hosted on Netlify.',
    skills: ["React", "Javascript", "HTML", "CSS"],
    url: 'https://happy-kirch-922c4e.netlify.app/',
    repo: 'https://github.com/samgold2020/Personal-Portfolio',
    image: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=2313&q=80',
    alt: "chicago skyline", 
   },
  { 
    id: 4,
    title: 'Meals for Two',
    url: 'https://github.com/samgold2020/MealsForYou',
    repo: 'https://github.com/samgold2020/MealsForYou',
    description: 'This front end recipes app utilizes a popular API, MealsDB, to render fetch calls. Built with RESTful routes you can search by ingredient or generate a random recipe.',
    image: 'https://images.unsplash.com/photo-1564149504298-00c351fd7f16?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1650&q=80', 
    alt: "spoon spices", 
   },
   { 
    id: 5,
    title: 'Flipcards',
    url: 'https://samgold2020.github.io/Flipcards/',
    repo: 'https://github.com/samgold2020/Flipcards',
    description: 'Test your memory with this fun Vanilla Javascipt game!  Built with CSS grid, flipcard animation, DOM manipulation and a toggle for dark mode.',
    image: 'https://images.unsplash.com/photo-1592933517489-50318e52d74b?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80',
    alt: "playing cards",
   },
]
